export default{
        column: [
                {
                  type: 'select',
                  label: '项目名称',
                  dicData: [],
                  cascaderItem: [],
                  span: 6,
                  display: true,
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  prop: 'projectId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择下拉选择器'
                    }
                  ]
                },
                {
                  type: 'select',
                  label: '调出仓库',
                  dicData: [],
                  cascaderItem: [],
                  span: 6,
                  display: true,
                
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'originWarehouseId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择仓库'
                    }
                  ]
                },
                {
                  type: 'select',
                  label: '调入仓库',
                  dicData: [],
                  cascaderItem: [],
                  span: 6,
                  display: true,
                
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'destWarehouseId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择仓库'
                    }
                  ]
                },
                {
                  label:'申请人',
                  prop:'applyUserName',
                  span:6,
                },
               
                {
                  type: 'tree',
                  label: '申请人',
                  dicData: [],
                  span: 6,
                  display: false,
                  filterable:true,
                  // formslot:true,
                  dataType:'string',
                  props: {
                    label: 'label',
                    value: 'value'
                  },
                  prop: 'applyUserId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择申请人'
                    }
                  ]
                },
                {
                  type: 'input',
                  label: '调拨单号',
                  disabled:true,
                  span:8,
                  prop: 'allotNo',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '单号'
                    }
                  ]
                },
                {
                  type: 'datetime',
                  label: '申请时间',
                  cascaderItem: [],
                  span: 8,
                  disabled:true,
                  display: true,
                  dicOption: 'static',
                  props: {
                    label: 'label',
                    value: 'value'
                  },
                  prop: 'applyTime',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择下拉选择器'
                    }
                  ],
                  value:new Date(),
                  format: 'yyyy-MM-dd HH:mm:ss',
                  valueFormat: 'yyyy-MM-dd HH:mm:ss'
                },
                {
                  type: 'textarea',
                  label: '备注',
                  span: 24,
                  maxlength: 300,
                  showWordLimit: true,
                  display: true,
                  prop: 'remark'
                },
                {
                  type: 'textarea',
                  label: '',
                  labelWidth:0,
                  span: 24,
                  formslot:true,
                  display: true,
                  prop: 'dataList'
                }
              ],
              labelPosition: 'right',
              labelSuffix: '：',
              labelWidth: 100,
              gutter: 0,
              submitBtn: true,
              submitIcon:'none',
              submitText: '保存',
              emptyBtn:false,
              menuBtn: false,
              menuPosition: 'center',
              disabled:false,
              
}
